import { createSlice } from "@reduxjs/toolkit";
import {
  createXfindGoogleAuth,
  logoutUser,
  signup,
  signin,
} from "../3- actions/users";

export const counterSlice = createSlice({
  name: "auth",
  initialState: {
    authData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createXfindGoogleAuth.fulfilled, (state, action) => {
      localStorage.setItem("profile", JSON.stringify({ ...action?.payload }));
      state.authData = action.payload;
      window.location.reload();
    });
    builder.addCase(logoutUser.fulfilled, (state, action) => {
      localStorage.clear();
      state.authData = null;
      window.location.reload();
    });
    builder.addCase(signup.fulfilled, (state, action) => {
      localStorage.setItem("profile", JSON.stringify({ ...action?.payload }));
      state.authData = action.payload;
      setTimeout(() => {
        window.location.reload();
      }, 500);
    });
    builder.addCase(signup.rejected, (state, action) => {
      state.error = { error: action.payload || "Server Error" };
    });
    builder.addCase(signin.fulfilled, (state, action) => {
      localStorage.setItem("profile", JSON.stringify({ ...action?.payload }));
      state.authData = action.payload;
      setTimeout(() => {
        window.location.reload();
      }, 500);
    });
    builder.addCase(signin.rejected, (state, action) => {
      state.error = { error: action.payload || "Server Error" };
    });
  },
});

export default counterSlice.reducer;
